import React from 'react'

interface PlusIconProps {
  width?: number
  height?: number
  style?: React.CSSProperties
}

export const PlusIcon: React.FC<PlusIconProps> = ({
  width = 17,
  height = 17,
  style
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 17 17"
      fill="none"
      style={style}
    >
      <path
        d="M12.7416 9.41976H8.7416V13.4198H7.40826V9.41976H3.40826V8.08643H7.40826V4.08643H8.7416V8.08643H12.7416V9.41976Z"
        fill="#2B42B3"
      />
    </svg>
  )
}

export default PlusIcon
